import { DEFAULT_ICONS } from '@plugins/shared/types/icon';

/**
 * Icons offered to editors for quick link groups and links. A superset of the
 * picker defaults, extended with Font Awesome 4 names that cover the usual
 * intranet categories (HR, travel, IT, finance, culture).
 *
 * The same list backs the server side `@IsIn` check, so the picker can never
 * produce a value the API rejects.
 */
export const QUICK_LINK_ICONS = [
  ...DEFAULT_ICONS,
  'user-md',
  'plane',
  'laptop',
  'money',
  'graduation-cap',
  'life-ring',
  'building',
  'briefcase',
  'calendar',
  'envelope',
  'phone',
  'file-text-o',
  'folder-open',
  'globe',
  'info-circle',
  'question-circle',
  'shield',
  'book',
  'bus',
  'coffee',
  'credit-card',
  'clock-o',
  'headphones',
  'home',
  'key',
  'map-marker',
  'newspaper-o',
  'pie-chart',
  'sitemap',
  'ticket',
  'truck',
  'university',
];

/** Upper bounds shared by the backoffice form and the server validators. */
export const QUICK_LINK_MAX_GROUPS = 20;
export const QUICK_LINK_MAX_LINKS = 20;
export const QUICK_LINK_MAX_LABEL_LENGTH = 255;
